import { useEffect } from "react";

import { Box } from "@/storybook-components";

import { sanitizeHref } from "@/lib";
import { useAppSelector } from "@/redux/store/hooks";

const NavLinks = () => {
  const { homePageRevision } = useAppSelector(
    (state) => state.homePageRevision
  );
  const { headerLinks } = useAppSelector((state) => state.navigationLinks);
  const backgroundColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarBackgroundColor;
  const textColor =
    homePageRevision?.sections?.sections[0].theme.mainNavbarTextColor;

  useEffect(() => {
    // @ts-ignore
    if (typeof MetisMenu !== "function") return;

    // @ts-ignore
    // eslint-disable-next-line no-undef
    const dropdownMenu = new MetisMenu("#js-nav-links").on(
      "shown.metisMenu",
      function (event) {
        const shownElement = event.detail.shownElement as HTMLElement;
        const handleOutsideClick = (e: { target: unknown }) => {
          const target = e.target;
          if (!(target instanceof Element) || !shownElement.contains(target)) {
            dropdownMenu.hide(shownElement);
            window.removeEventListener("mousedown", handleOutsideClick);
          }
        };
        window.addEventListener("mousedown", handleOutsideClick);
      }
    );

    return () => {
      dropdownMenu.dispose();
    };
  }, []);

  const dropdownNode = (item, index) => {
    if (item.children.length) {
      return (
        <li key={index} className="nav-links__list__list-item">
          <a
            href={sanitizeHref(item.linkableUrl)}
            aria-expanded="false"
            className="nav-links__list__list-item__link"
            data-testid={`participant-header-nav-dropdown-${item.id ?? index}`}
          >
            <span>{item.title}</span>
          </a>
          <Box
            as="ul"
            className="nav-links__list__list-item__child mm-collapse"
            color={textColor}
            backgroundColor={backgroundColor}
          >
            {item.children.map((child, childIndex) => {
              return dropdownNode(child, childIndex);
            })}
          </Box>
        </li>
      );
    }
    return (
      <li key={index} className="nav-links__list__list-item">
        <a
          href={sanitizeHref(item.linkableUrl)}
          className="metismenu nav-links__list__list-item__link"
          data-testid={`participant-header-nav-link-${item.id ?? index}`}
        >
          <span>{item.title}</span>
        </a>
      </li>
    );
  };

  headerLinks.map((l) => !l.children && (l.children = []));

  const links = headerLinks.filter((l) => l.parentId === null);

  return (
    <div className="nav-links">
      <ul className="metismenu nav-links__list" id="js-nav-links">
        {links.map((item, index) => {
          return dropdownNode(item, index);
        })}
      </ul>
    </div>
  );
};

export default NavLinks;
